import { type SaleMode } from '@paulownia/shared/types';
import { Package, Scale, Users, PackageOpen, ShoppingBasket } from 'lucide-react';

export interface SaleModeOption {
  mode: SaleMode;
  label: string;
  description: string;
  example: string;
  icon: React.ComponentType<{ className?: string }>;
}

export const SALE_MODES: SaleModeOption[] = [
  {
    mode: 'UNIT',
    label: 'Pièce prix fixe',
    description: 'Vendu à l\'unité avec un prix fixe',
    example: 'Tarte, bouteille, coffret personnalisable',
    icon: Package,
  },
  {
    mode: 'UNIT_PRICED_BY_WEIGHT',
    label: 'Pièce facturée au poids',
    description: 'Vendu à la pièce mais le prix dépend du poids',
    example: 'Poulet rôti, poisson entier',
    icon: ShoppingBasket,
  },
  {
    mode: 'WEIGHT',
    label: 'Poids libre',
    description: 'Le client choisit le poids souhaité',
    example: 'Olives, fromage à la coupe',
    icon: Scale,
  },
  {
    mode: 'WEIGHT_ESTIMATED',
    label: 'Poids par personnes',
    description: 'Le client choisit le nombre de personnes',
    example: 'Rôti pour 4 personnes',
    icon: Users,
  },
  {
    mode: 'WEIGHT_PACKAGED',
    label: 'Formats fixes',
    description: 'Le client choisit parmi des formats prédéfinis',
    example: 'Café 250g, 500g, 1kg',
    icon: PackageOpen,
  },
];
